import React, {
	Component
} from 'react';
import './index.css';
import {
	GuitarChord,
	ChordName,
	ChordSvg
} from '../../guitarChord.js';
class ChordDraw extends Component {
	constructor(props) {
		super(props);
		this.state = {
			info: "",
		}
		this.info = {
			hasAnswer: [
				""
			],
			hasSvg: [
				""
			],
			noAnswer: [
				"未知和弦 (和弦音不要有重复)"
			],
		}
	}
	randomOne(arr) {
		return arr[Math.floor(Math.random() * arr.length)];
	}
	draw(chordTone) {
		let chord = new GuitarChord();
		let chordName = new ChordName().getChordName(chordTone);
		let chordResult = chord.chord(chordTone);
		let svg = new ChordSvg();
		let container = document.getElementById("chord_draw");
		container.innerHTML = "";

		setTimeout(() => {
			this.props.hideLoading();
		}, 200);
		setTimeout(() => {
			if (chordResult.length === 0) {
				this.setState({
					info: this.randomOne(this.info.noAnswer)
				});
			} else if (/\.\.\./.test(chordName)) {
				this.setState({
					info: this.randomOne(this.info.hasSvg)
				});
			} else {
				this.setState({
					info: this.randomOne(this.info.hasAnswer)
				});
			}
			chordResult.forEach((chordItem) => {
				svg.drawChord(chordTone, chordItem, document.getElementById("chord_draw"));
			});
		}, 500);

	}
	render() {
		return (
			<div className="container-chordDraw">
				<div className={"draw-info"+(this.state.info?" show":"")}>{this.state.info}</div>
        		<div id="chord_draw"></div>
      		</div>
		);
	}
}

export default ChordDraw;


// WEBPACK FOOTER //
// ./src/component/chordDraw/index.js